import { useLayoutEffect } from "react";

/**
 * Smoothly re-anchors a scroll container to its bottom whenever `key` changes,
 * unless `enabled` is false. The profiling conversation calls this after a new
 * agent message finishes typing and after the composer band is (re)measured —
 * both grow the container's scrollHeight *after* layout, so an imperative scroll
 * at the call site would race the reflow and under-shoot (leaving the newest
 * message hidden behind the composer). A layout effect runs once the DOM has
 * settled. Disabled on the feed-taste turn, where the user scrolls the feed
 * manually to reveal the CTA.
 */
export function useScrollPinToBottom(
  ref: React.RefObject<HTMLDivElement | null>,
  key: string,
  enabled: boolean
): void {
  useLayoutEffect(() => {
    if (!enabled) return;
    const el = ref.current;
    if (el === null) return;
    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [ref, key, enabled]);
}
